<template>
  <q-card flat :style="$q.screen.lt.md?'':'min-width: 500px'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>نوع چاپ را انتخاب کنید</span>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-select v-model="selectedPrintForm"
                :options="printList"
                option-value="url"
                option-label="title"
                filled
                label="نوع گزارش خود را انتخاب کنید"
      />
    </q-card-section>
    <q-card-actions align="left">
      <q-btn label="تایید" @click="loadReport" icon="done" color="primary"/>
      <q-btn label="انصراف" v-close-popup icon="cancel" color="red" flat class="q-ml-sm"/>
    </q-card-actions>
  </q-card>
</template>

<script>
export default {
  name: 'PrintList',
  components: {},
  props: {
    title: {
      type: String,
      required: true,
      default: () => 'گزارش'
    },
    printList: {
      type: Array,
      default: () => {
      }
    }
  },
  data() {
    return {
      selectedPrintForm: undefined
    }
  },
  methods: {
    loadReport() {
      if (this.selectedPrintForm) {
        this.$emit('report-selected', this.selectedPrintForm)
      } else {
        this.$q.notify(
            {
              type: 'negative',
              color: 'negative',
              position:'top',
              message: 'نوع گزارش را انتخاب نمایید'
            })
      }
    }
  }
}
</script>